import { PencilLine, Plus } from 'lucide-react';

import type { ActivityIconProps } from './types';

export function ActivityIcon({ type }: ActivityIconProps) {
  if (type === 'created') {
    return (
      <div className="flex size-6 items-center justify-center rounded-full bg-green-500/20 text-green-500">
        <Plus className="size-3.5" />
      </div>
    );
  }
  return (
    <div className="flex size-6 items-center justify-center rounded-full bg-blue-500/20 text-blue-500">
      <PencilLine className="size-3.5" />
    </div>
  );
}
